import { withTheme } from 'styled-components';
import {
    TeamAdminContainer,
    TeamAdminNavPanel,
    CategoryName,
    PanelTitle,
    MainContent,
    CardsContainer,
    TeamListContainer,
    PageContent,
} from './styles';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { Fragment, useEffect, useRef, useState } from 'react';
import {
    FovDivider,
    FovOption,
    FovSelect,
    H3,
    H4,
    HorizontalSpacer,
    PageError,
    VerticalSpacer,
} from 'components';
import { NoAdminAccessText, NoTeamsText } from './ErrorPages';
import { teamAdminItems } from './AdminItems';
import { useCookies } from 'react-cookie';
import { setSelectedTeam } from 'store/actions/teamData';

const TeamAdmin = withTheme(props => {
    const { theme } = props;
    const userDataStore = useSelector(state => state.userData);
    const [ cookies ] = useCookies([ 'userAuth' ]);
    const token = cookies.archvision_token;
    const selectedTheme = userDataStore.userPreferences.theme;
    const { pathname } = useLocation();
    const dispatch = useDispatch();
    const onTeamAdmin = pathname.includes('/team-admin');
    const ref = useRef();
    const navigate = useNavigate();
    const scrollToTop = () => ref.current?.scrollTo(0,0);


    const userHasTeam = userDataStore.data.teams && userDataStore.data.teams.length > 0;

    if (!userHasTeam) {
        return (
            <PageError
                title='Access denied'
                text={<NoTeamsText />}
        />
        );

    }

    const userIsAdmin = userHasTeam && userDataStore.data.teams.find(team => team.role === 'admin');

    // TODO: Add admin emails to text
    if (!userIsAdmin) {
        return (
            <PageError
                title='Access denied'
                text={<NoAdminAccessText teams={userDataStore.data.teams} />}
            />
        );

    }

    const userAdminTeams = userDataStore.data.teams.filter(team => team.role === 'admin');
    const showTeamSelect = userAdminTeams.length > 1;
    const [ selectedTeamId, setSelectedTeamId ] = useState(userAdminTeams[0].teamId);


    const buildTeamAdminNav = () => {
        return teamAdminItems.map((item, index) => (
            <Fragment key={index}>
                <CategoryName
                    key={index}
                    theme={theme}
                    $selectedTheme={selectedTheme}
                    $selected={pathname === item.path}
                    onClick={() => {
                        if (item.action) {
                            dispatch(item.action(token, selectedTeamId));
                        }
                        navigate(item.path);
                        scrollToTop();
                    }}
                >
                    <HorizontalSpacer size={25} />
                    {item.title}
                </CategoryName>
                <VerticalSpacer size={20} />
            </Fragment>
        ));
    };

    const selectedTeam = userDataStore.data.teams?.find(team => team.teamId === selectedTeamId);
    const selectedPage = teamAdminItems.find(item => item.path === pathname);

    useEffect(() => {
        dispatch(setSelectedTeam(selectedTeamId));
    }, [ selectedTeamId ]);

    const buildAdminTeamOptions = () => {
        return userAdminTeams.map(team => (
            <FovOption key={team.teamId} value={team.teamId}>
                {team.teamName}
            </FovOption>
        ));
    };

    return (
        <TeamAdminContainer theme={theme} $selectedTheme={selectedTheme} $onTeamAdmin={onTeamAdmin}>
        {onTeamAdmin && (
            <TeamAdminNavPanel theme={theme} $selectedTheme={selectedTheme}>

            {showTeamSelect &&
                <Fragment>
                    <H4>Select a team:</H4>
                    <VerticalSpacer size={10} />
                    <TeamListContainer>
                        <FovSelect
                        // eslint-disable-next-line
                        value={selectedTeamId}
                        placeholder={'Select a team.'}
                        onChange={(e,newVal) => {
                            if (selectedTeamId !== newVal) {
                                setSelectedTeamId(newVal);
                            }
                        }}
                        >
                        {buildAdminTeamOptions()}
                        </FovSelect>
                    </TeamListContainer>
                    <VerticalSpacer size={15} />
                    <FovDivider />
                    <VerticalSpacer size={15} />
                </Fragment>
            }
            <PanelTitle>
                <H4>{selectedTeam.teamName}</H4>
            </PanelTitle>
            <VerticalSpacer size={20} />
            {buildTeamAdminNav()}
            </TeamAdminNavPanel>
        )}

        <MainContent ref={ref}>
            <CardsContainer theme={theme} $selectedTheme={selectedTheme} $onTeamAdmin={onTeamAdmin}>
            {selectedPage &&
                <PageContent>
                    <VerticalSpacer size={43} />
                    <H3>{selectedPage.title}</H3>
                    <VerticalSpacer size={7} />
                    {selectedPage.element}
                </PageContent>
            }
            </CardsContainer>
        </MainContent>

        </TeamAdminContainer>
    );

});

export { TeamAdmin };
